import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export const NewStoriesButton = ({ className, onClick, style }) => (
  <button
    type="button"
    className={`${cx('new-stories-btn')} ${className}`}
    onClick={onClick}
    style={style}
  >
    <FontAwesomeIcon icon={faRedo} />
    <span className={cx('text')}>See New Stories</span>
  </button>
);

NewStoriesButton.defaultProps = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

NewStoriesButton.defaultProps = {
  className: '',
  onClick() {},
  style: {},
};

export default withComponentName(NewStoriesButton);
